import { MediaCardProps } from "../components/MediaCard/MediaCard";

export const mediaCards: MediaCardProps[] = [
  {
    id: "se01-showroom-entrance",
    imageUrl: "https://media-management-poc.web.app/assets/se01-CSiWiab_.jpg",
    imageAlt: "Showroom entrance with a living room display",
    images: [
      "https://media-management-poc.web.app/assets/l00-9Q_bn2bq.jpg",
      "https://media-management-poc.web.app/assets/l00-render-1-B59KH-yV.png",
      "https://media-management-poc.web.app/assets/l00-render-4-CY3ym6Kk.png",
      "https://media-management-poc.web.app/assets/l00-render-7-CJRhnYIV.png",
      "https://media-management-poc.web.app/assets/l00-9Q_bn2bq.jpg",
      "https://media-management-poc.web.app/assets/l00-render-1-B59KH-yV.png",
      "https://media-management-poc.web.app/assets/l00-render-4-CY3ym6Kk.png",
      "https://media-management-poc.web.app/assets/l00-render-7-CJRhnYIV.png",
      "https://media-management-poc.web.app/assets/l00-9Q_bn2bq.jpg",
      "https://media-management-poc.web.app/assets/l00-render-1-B59KH-yV.png",
      "https://media-management-poc.web.app/assets/l00-render-4-CY3ym6Kk.png",
      "https://media-management-poc.web.app/assets/l00-render-7-CJRhnYIV.png",
      "https://media-management-poc.web.app/assets/l00-9Q_bn2bq.jpg",
      "https://media-management-poc.web.app/assets/l00-render-1-B59KH-yV.png",
      "https://media-management-poc.web.app/assets/l00-render-4-CY3ym6Kk.png",
      "https://media-management-poc.web.app/assets/l00-render-7-CJRhnYIV.png",
    ],
    badgeLabel: "Launch 4",
    title: "SE01: Showroom entrance — TERRSJÖ/TONSTAD",
    fiscalYear: "FY26",
    mediaType: "ROOM_SETTING",
    location: "Showroom entrance",
    status: "Published",
    publishedDate: "2026-08-01",
  },
  {
    id: "l00-living-room",
    imageUrl: "https://media-management-poc.web.app/assets/l00-9Q_bn2bq.jpg",
    imageAlt: "Living room display with storage furniture",
    images: [
      "https://media-management-poc.web.app/assets/l00-9Q_bn2bq.jpg",
      "https://media-management-poc.web.app/assets/kv00-BKuN4alY.jpg",
    ],
    badgeLabel: "Launch 4",
    title: "L00: Living room — SALTMYRAN/KALLAX",
    fiscalYear: "FY26",
    mediaType: "ROOM_SETTING",
    location: "Living room",
    status: "Unpublished",
    publishedDate: "2026-08-01",
  },
  {
    id: "b05-bedroom",
    imageUrl: "https://media-management-poc.web.app/assets/b05-d-7mTTaX.jpg",
    imageAlt: "Bedroom display with RÅDMANSÖ furniture",
    images: [
      "https://media-management-poc.web.app/assets/b05-d-7mTTaX.jpg",
      "https://media-management-poc.web.app/assets/mabarsskar-BWBToKNO.jpg",
      "https://media-management-poc.web.app/assets/se01-CSiWiab_.jpg",
    ],
    badgeLabel: "Launch 4",
    title: "B05: Bedroom — RÅDMANSÖ",
    fiscalYear: "FY26",
    mediaType: "ROOM_SETTING",
    location: "Bedroom",
    status: "Published",
    publishedDate: "2026-08-01",
  },
  {
    id: "kv00-kitchen",
    imageUrl: "https://media-management-poc.web.app/assets/kv00-BKuN4alY.jpg",
    imageAlt: "Kitchen display with ASPUDDEN furniture",
    images: [
      "https://media-management-poc.web.app/assets/kv00-BKuN4alY.jpg",
      "https://media-management-poc.web.app/assets/l00-9Q_bn2bq.jpg",
    ],
    badgeLabel: "Launch 4",
    title: "KV00: Kitchen — ASPUDDEN",
    fiscalYear: "FY26",
    mediaType: "VIGNETTE",
    location: "Kitchen",
    status: "Published",
    publishedDate: "2026-08-01",
  },
  {
    id: "mabarsskar-staircase-entrance",
    imageUrl:
      "https://media-management-poc.web.app/assets/mabarsskar-BWBToKNO.jpg",
    imageAlt: "Staircase entrance display with MÅBÄRSSKÄR products",
    images: [
      "https://media-management-poc.web.app/assets/mabarsskar-BWBToKNO.jpg",
      "https://media-management-poc.web.app/assets/b05-d-7mTTaX.jpg",
    ],
    badgeLabel: "Launch 4",
    title: "Staircase entrance — MÅBÄRSSKÄR",
    fiscalYear: "FY26",
    mediaType: "STATEMENT_MEDIA",
    location: "Staircase entrance",
    status: "Published",
    publishedDate: "2026-08-01",
  },
  {
    id: "d01-dining-room",
    imageUrl: "https://media-management-poc.web.app/assets/se01-CSiWiab_.jpg",
    imageAlt: "Dining room display with neutral wood and textile styling",
    images: [
      "https://media-management-poc.web.app/assets/se01-CSiWiab_.jpg",
      "https://media-management-poc.web.app/assets/kv00-BKuN4alY.jpg",
    ],
    badgeLabel: "Launch 4",
    title: "D01: Dining room — TOSTERÖD",
    fiscalYear: "FY26",
    mediaType: "ROOM_SETTING",
    location: "Dining room",
    status: "Published",
    publishedDate: "2026-08-01",
  },
  {
    id: "l12-storage-wall",
    imageUrl: "https://media-management-poc.web.app/assets/l00-9Q_bn2bq.jpg",
    imageAlt: "Storage wall with acoustic and shelving styling",
    images: [
      "https://media-management-poc.web.app/assets/l00-9Q_bn2bq.jpg",
      "https://media-management-poc.web.app/assets/b05-d-7mTTaX.jpg",
    ],
    badgeLabel: "Launch 4",
    title: "L12: Storage wall — BILLY/HEMNES",
    fiscalYear: "FY26",
    mediaType: "VIGNETTE",
    location: "Storage wall",
    status: "Unpublished",
    publishedDate: "2026-08-01",
  },
  {
    id: "b12-bedroom",
    imageUrl: "https://media-management-poc.web.app/assets/b05-d-7mTTaX.jpg",
    imageAlt: "Bedroom styling with layered textiles and lighting",
    images: [
      "https://media-management-poc.web.app/assets/b05-d-7mTTaX.jpg",
      "https://media-management-poc.web.app/assets/mabarsskar-BWBToKNO.jpg",
    ],
    badgeLabel: "Launch 4",
    title: "B12: Bedroom — HEMNES",
    fiscalYear: "FY26",
    mediaType: "ROOM_SETTING",
    location: "Bedroom",
    status: "Published",
    publishedDate: "2026-08-01",
  },
  {
    id: "kv07-kitchen",
    imageUrl: "https://media-management-poc.web.app/assets/kv00-BKuN4alY.jpg",
    imageAlt: "Kitchen island scenario with countertop accessories",
    images: [
      "https://media-management-poc.web.app/assets/kv00-BKuN4alY.jpg",
      "https://media-management-poc.web.app/assets/se01-CSiWiab_.jpg",
    ],
    badgeLabel: "Launch 4",
    title: "KV07: Kitchen — KNOXHULT",
    fiscalYear: "FY26",
    mediaType: "STATEMENT_MEDIA",
    location: "Kitchen",
    status: "Published",
    publishedDate: "2026-08-01",
  },
  {
    id: "stockholm-voxla-entryway",
    imageUrl:
      "https://media-management-poc.web.app/assets/mabarsskar-BWBToKNO.jpg",
    imageAlt: "Entryway with storage and decor accessory styling",
    images: [
      "https://media-management-poc.web.app/assets/mabarsskar-BWBToKNO.jpg",
      "https://media-management-poc.web.app/assets/l00-9Q_bn2bq.jpg",
    ],
    badgeLabel: "Launch 4",
    title: "Entryway — STOCKHOLM/VOXLA",
    fiscalYear: "FY26",
    mediaType: "ROOM_SETTING",
    location: "Entryway",
    status: "Published",
    publishedDate: "2026-08-01",
  },
];

export const reasonForChange =
  "To emphasise the FY26 Extraordinary focus – Complete cooking and eating – in Launch 4.";

// Mirrors the media type taxonomy used across the Media Management POC.
export const MEDIA_TYPE_OPTIONS: string[] = [
  "HOME",
  "ROOM_SETTING",
  "VIGNETTE",
  "PRODUCT_DOMINANCE_WALL",
  "ALL_PARTS_STUDIO",
  "SELECTION_POINT",
  "DISPLAY_COMPACT",
  "CROSS_OVER_MEDIA",
  "SHOWCASE",
  "COORDINATION_MEDIA",
  "VITALITY_MEDIA",
  "STATEMENT_MEDIA",
  "PERIMETER_BREAK",
  "FRONT_MEDIA",
  "OPEN_THE_WALLET",
  "OPENING_OFFER",
];

import { Article } from "@coworker/app/src/components/RoomSettings/types/article";
import { Item } from "@coworker/apprestructured/src/shared/types/item";
import { ItemBadge } from "@coworker/apprestructured/src/shared/types/ItemBadge";

type MediaDetailProduct = {
  item: Item;
  article: Article;
  badges: ItemBadge[];
  saleStartDate?: string;
};

const createArticle = (id: string, mediaId: string): Article => ({
  id: `article-${id}`,
  active: "ACTIVE",
  itemName: "",
  itemType: "ART",
  itemColor: "",
  imageSmall: "",
  nbrArticles: 1,
  hfb: "",
  productArticleType: "ART",
  productArticleId: id,
  mediaId,
  supplierNumber: undefined,
  dateStamp: undefined,
  createdAt: "2026-01-01T00:00:00.000Z",
});

const createProduct = (
  id: string,
  name: string,
  description: string,
  imageUrl: string,
  mediaId: string,
  badges: ItemBadge[],
  saleStartDate?: string
): MediaDetailProduct => ({
  item: {
    no: id,
    type: "ART",
    name,
    noFormatted: `${id.slice(0, 3)}.${id.slice(3, 6)}.${id.slice(6)}`,
    description,
    productTypeName: "Product",
    paNo: id,
    hfbNo: "",
    source: "GLOBAL",
    smallImageUrl: imageUrl,
  },
  article: createArticle(id, mediaId),
  badges,
  saleStartDate,
});

export const mediaDetailProducts = (mediaId: string): MediaDetailProduct[] => [
  createProduct(
    "90512345",
    "TERRSJÖ",
    "Desk, red-brown water pattern, 46x80 cm",
    "https://www.ikea.com/se/en/images/products/lagkapten-alex-desk-white__1100735_pe866360_s5.jpg",
    mediaId,
    [
      { text: "Main product", colour: "blue" },
      { text: "New", colour: "orange" },
      { text: "Low price", colour: "grey" },
    ],
    "2026-10-01"
  ),
  createProduct(
    "70456789",
    "KALLAX",
    "Shelving unit with 4 inserts, white, 147x77 cm",
    "https://www.ikea.com/se/en/images/products/kallax-shelving-unit-white__0644754_pe702552_s5.jpg",
    mediaId,
    [
      { text: "New", colour: "orange" },
      { text: "Low price", colour: "grey" },
    ],
    "2026-10-01"
  ),
  createProduct(
    "30567890",
    "TERRSJÖ",
    "Dining chair, red-brown water pattern",
    "https://www.ikea.com/se/en/images/products/teodores-chair-white__0727329_pe735495_s5.jpg",
    mediaId,
    [
      { text: "New", colour: "orange" },
      { text: "Low price", colour: "grey" },
    ],
    "2026-10-01"
  ),
  createProduct(
    "80345671",
    "KALLAX",
    "Shelf insert with door, white, 33x33 cm",
    "https://www.ikea.com/se/en/images/products/kallax-insert-with-door-white__0711168_pe727855_s5.jpg",
    mediaId,
    [
      { text: "Main product", colour: "blue" },
      { text: "Low price", colour: "grey" },
    ],
    "2026-10-01"
  ),
  createProduct(
    "60123456",
    "TERRSJÖ",
    "Bar stool, red-brown water pattern",
    "https://www.ikea.com/se/en/images/products/franklin-bar-stool-foldable-black-black__0727359_pe735522_s5.jpg",
    mediaId,
    [{ text: "Tactical launch article", colour: "green" }],
    "2026-10-01"
  ),
  createProduct(
    "40876543",
    "KALLAX",
    "Shelf unit with 4 inserts, white, 147x77 cm",
    "https://www.ikea.com/se/en/images/products/kallax-shelving-unit-white__0644754_pe702552_s5.jpg",
    mediaId,
    [{ text: "New", colour: "orange" }],
    "2026-10-01"
  ),
];
